import { EFieldNames } from '@shared/models/Enums/EFieldNames';
import { FormFieldModel } from '@shared/models/LoginModels/FormFieldModel';
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators';
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '@shared/models/constants';

export interface ResetPasswordModel {
  email: string;
  token: string;
  password: string;
}

export const recoveryPasswordModel = {
  [EFieldNames.Password]: '',
  [EFieldNames.ConfirmPassword]: '',
};

export const recoveryPasswordFields: { [key: string]: FormFieldModel } = {
  [EFieldNames.Password]: {
    label: 'New Password',
    icon: 'mdi-lock-outline',
    type: 'password',
    errors: {
      required: 'Password is required',
      minLength: `Password min length is ${PASSWORD_MIN_LENGTH}`,
      maxLength: `Password max lenght is ${PASSWORD_MAX_LENGTH}`
    },
  },
  [EFieldNames.ConfirmPassword]: {
    label: 'Confirm password',
    icon: 'mdi-lock-outline',
    type: 'confirmPassword',
    errors: {
      required: 'Password confirmation is required',
      sameAsPassword: 'Passwords must be identical',
    },
  },
};

export const recoveryPasswordValidation = {
  [EFieldNames.Password]: {
    required,
    minLength: minLength(PASSWORD_MIN_LENGTH),
    maxLength: maxLength(PASSWORD_MAX_LENGTH)
  },
  [EFieldNames.ConfirmPassword]: {
    required,
    sameAsPassword: sameAs(EFieldNames.Password),
  },
};
